export { default as NewsStore } from './NewsStore';
import * as React from 'react';

import NewsStore from './NewsStore';
import { NewsStoreContext, NewsStoreProvider } from './context';

const useNewsStore = (): NewsStore | null => {
  const newsStoreContext = React.useContext(NewsStoreContext);

  if (!newsStoreContext) {
    return null;
  }

  return newsStoreContext.store;
};

export { NewsStoreContext, NewsStoreProvider, useNewsStore };
